import { SpaceBetween, FormField, DatePicker, Select, Button } from '@cloudscape-design/components';
import { useEffect, useMemo, useState } from 'react';
import { SalesRep, ZohoContact } from '../common/types';

export type SalesRepFilterProps = {
  date: string;
  setDate: (date: string) => void;
  days: number;
  setDays: (days: number) => void;
  salesRep: SalesRep | undefined;
  setSalesRep: (salesRep: SalesRep) => void;
  salesReps: SalesRep[];
  refresh: () => void;
  loading: boolean;
};

export function SalesRepFilter(props: SalesRepFilterProps) {
  const { date, setDate, days, setDays, refresh, loading, salesRep, setSalesRep, salesReps } = props;
  const options = [
    { label: '7 Days', value: '7' },
    { label: '30 Days', value: '30' },
    { label: '60 Days', value: '60' },
    { label: '90 Days', value: '90' },
  ];

  // const currencyOptions = [
  //   { label: 'NeedZappy CA', value: 'CAD' },
  //   { label: 'NeedZappy USA', value: 'USD' },
  // ];
  const salesRepOptions = useMemo(() => {
    const options = salesReps.map((rep) => ({ label: rep.full_name, value: rep.crm_id }));

    options.unshift({ label: 'All', value: 'all' });

    options.push({ label: 'None', value: 'none' });

    return options;
  }, [salesReps]);

  const [localDate, setLocalDate] = useState(date);

  useEffect(() => {
    setLocalDate(date);
  }, [date]);

  return (
    <SpaceBetween direction="horizontal" size="s">
      <FormField constraintText="Use YYYY/MM/DD format." label="Reporting Date">
        <DatePicker
          disabled={loading}
          locale="en-US"
          openCalendarAriaLabel={(selectedDate) =>
            'Choose reporting date' + (selectedDate ? `, selected date is ${selectedDate}` : '')
          }
          placeholder="YYYY/MM/DD"
          value={localDate}
          expandToViewport
          onChange={({ detail }) => {
            const newDate = detail.value;
            setLocalDate(newDate);

            // Need to check that the date is actually in YYYY-MM-DD format
            if (newDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
              setDate(newDate);
            }
          }}
        />
      </FormField>
      <FormField
        constraintText="Comparison period."
        label={days === 1 ? `Previous ${days} day` : `Previous ${days} days`}
      >
        <Select
          disabled={loading}
          options={options}
          selectedOption={options.find((option) => option.value === days.toString()) || options[0]}
          expandToViewport
          onChange={({ detail }) =>
            setDays(Math.max(parseInt(detail.selectedOption.value ?? '30'), 1))
          }
        />
      </FormField>
      <FormField label="Sales Manager">
        <Select
          disabled={loading}
          options={salesRepOptions}
          selectedOption={salesRepOptions.find((option) => option.value === salesRep?.crm_id) || salesRepOptions[0]}
          expandToViewport
          onChange={({ detail }) => {
            const rep = salesReps.find((rep) => rep.crm_id === detail.selectedOption.value);

            if (rep) {
              setSalesRep(rep);
            } else if (detail.selectedOption.value === 'none') {
              setSalesRep({ crm_id: 'none', full_name: 'None' });
            } else {
              setSalesRep({ crm_id: 'all', full_name: 'All' });
            }
          }}
        />
      </FormField>
      <FormField label="Refresh">
        <Button disabled={loading} iconName="refresh" onClick={refresh} />
      </FormField>
    </SpaceBetween>
  );
}
